module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', [_c('div', {
    staticClass: "microphoneSetting flexcenter"
  }, [_c('div', {
    staticClass: "microphoneSettingDialog flexcenter"
  }, [_c('div', {
    staticClass: "align-left"
  }, [_c('p', [_vm._v("音声による入力が必要ですが、マイクから音声が正しく入力されていません。")]), _vm._v(" "), (_vm.isMobile) ? _c('p', [_vm._v("[音声機能]をオフにしますか？")]) : _c('p', [_vm._v("[マイクの設定]を開きますか？")])]), _vm._v(" "), _c('div', {
    staticClass: "flexbetween buttons"
  }, [_c('button', {
    staticClass: "offbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickSreOff
    }
  }, [_c('span', [_vm._v("音声機能を")]), _c('span', [_vm._v("オフにする")])]), _vm._v(" "), _c('button', {
    staticClass: "nobutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton(false)
      }
    }
  }, [_c('span', [_vm._v("いいえ")]), _c('span', {
    staticClass: "font12"
  }, [_vm._v("(このまま続ける)")])]), _vm._v(" "), (!_vm.isMobile) ? _c('button', {
    staticClass: "yesbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton(true)
      }
    }
  }, [_c('span', [_vm._v("はい")]), _c('span', {
    staticClass: "font12"
  }, [_vm._v("(設定を開く)")])]) : _vm._e()])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41e23814", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-41e23814","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MicrophoneSettingDialog.vue
// module id = 620
// module chunks = 1